import { memo, useState } from 'react';
import { CopyIcon } from '@chakra-ui/icons';
import { Tooltip } from '@chakra-ui/tooltip';

import { FileAttachment } from '@/modules/fileUploader/fileUploaderEntity';
import { PrimaryButton } from '@/uikit/component/Button';
import { copyTextToClipboard } from '@/shared/utils';

const initialStateTooltipCopy = {
  label: 'Copy Link',
  closeDelay: 0,
};

const FileUploaderCopyButton = memo(
  ({ files }: { files: Array<FileAttachment> }) => {
    const [tooltipCopy, setTooltipCopy] = useState(initialStateTooltipCopy);

    const onClickCopyAll = () => {
      try {
        const text = files.map((item) => item.url).join('\n');
        copyTextToClipboard(text);
        setTooltipCopy({ label: 'Copied', closeDelay: 3000 });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Could not copy: ', err);
      }
    };

    return (
      <Tooltip
        hasArrow
        label={tooltipCopy.label}
        closeDelay={tooltipCopy.closeDelay}
        closeOnClick={false}
        onClose={() => setTooltipCopy(initialStateTooltipCopy)}
      >
        <PrimaryButton
          onClick={onClickCopyAll}
          alignSelf="flex-end"
          leftIcon={<CopyIcon />}
          size="lg"
        >
          Copy All Links
        </PrimaryButton>
      </Tooltip>
    );
  },
);

export { FileUploaderCopyButton };
